import React from 'react';
import App from 'next/app';
import '../styles/index.scss';
import { TabProvider } from '../components/TabContext/TabContext';
import { DomainNameProvider } from '../components/Core/DynamicPage/DomainNameContext';

// InstantSearch renders nothing during static export, so it must stay scoped to
// SearchBlock (which provides its own) instead of wrapping the whole app.
class CustomApp extends App {
    render() {
        const { Component, pageProps } = this.props;

        return (
            <DomainNameProvider>
                <TabProvider>
                    <Component {...pageProps} />
                </TabProvider>
            </DomainNameProvider>
        )
    }
}

export default CustomApp;
